import lodash, { debounce, filter } from "lodash";
import React, { useCallback, useEffect, useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { DateFormetContext } from "../../../app/App.js";
import { CheckFloatValue } from "../../../utils/functions";
import { BatchBillingFilters } from "../BatchFilters";
import AccountSelectionTable from "./AccountSelectionTable";

const AccountsSelection = ({ ...props }) => {
  const formik = props;
  const initialFilters = {
    sort: {},
    filter: {
      billing_type:
      formik.values?.batch_type === "account"
      ? formik?.values?.billing_type
      : undefined,
    }
  };  

  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({ ...initialFilters });
  const [checkPage, setCheckPage] = useState([]);

  const [productData, setProductData] = useState();
  const [loading, setLoading] = useState(false)
  const [count, setCount] = useState();
  const [selectedAccounts, setSelectedAccounts] = useState(
    formik.values?.accounts ?? []
  );
  const [selectedAccountsWithAmount, setSelectedAccountsWithAmount] = useState(
    []
  );
  const [sumPrevious, setSumPrevious] = useState("");

  const [subTotalAmount, setSubTotalAmount] = useState([]);
  const [onClearList, setOnClearList] = useState(false);

  useEffect(() => {
    if (selectedAccounts && selectedAccounts?.length > 0) {
      const previous_amount_discount = formik.values?.amount_previous_type;
      let sum = 0;
      for (const i in selectedAccounts) {
        const formikAmount =
          formik.values?.amount_type === "%" && formik.values?.amount_previous
            ? (formik.values?.amount_previous / 100) *
            selectedAccounts[i]?.amount
            : formik.values?.amount_previous ?? 0;

        if (formik.values?.amount_type === "%") {
          sum +=
            selectedAccounts[i]?.amount +
            (previous_amount_discount === "add_amount"
              ? formikAmount
              : previous_amount_discount === "discount"
                ? -1 * formikAmount
                : 0);
        }
        else {
          if (previous_amount_discount === "discount") {
            sum += -1 * formikAmount
          }
          else {
            sum +=
              selectedAccounts[i]?.amount
          }
        }


        console.log('sum: ', sum);
        formik.setFieldValue("accounts", selectedAccounts);
        formik.setFieldValue("total_previous_amount", sum);
      }
      setSumPrevious(sum);
    }
  }, [selectedAccounts]);

  const getEditData = useCallback(async () => {
    if (formik.values?.isEdit) {
      const batchId = formik.values?.id;
      const token = await getAccessTokenSilently();
      FinanceService.editBatchBillingById(batchId, token).then((res) => {
        const result = res?.result?.accounts;
        setSelectedAccounts([...result]);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }
  }, [formik.values.isEdit, formik.values.id, getAccessTokenSilently]);
  useEffect(() => {
    getEditData();
  }, [getEditData]);
  const fetchMyAPI = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    // eslint-disable-next-line no-lone-blocks

    let payload = {
      sort: {
        name: 1,
      },
      filter: {
        amount_range: {
          amountFrom: +formik.values?.amount_range?.amountFrom,
          amountTo: +formik.values?.amount_range?.amountTo,
        },
        date_range: {
          date_type: formik?.values?.date_type,
          dateFrom: moment(formik.values?.start_date)
            .utcOffset("+0100")
            .format("YYYY-MM-DD"),
          dateTo: moment(formik.values?.end_date)
            .utcOffset("+0100")
            .format("YYYY-MM-DD"),
        },
        status: formik.values?.status,
        subLedger: formik.values?.SubLedger?.id,
        category:
          formik.values?.category_type?.name === ""
            ? undefined
            : formik.values?.category_type?.name,
        billing_type: formik.values.billing_type?.length > 0
          ? formik.values.billing_type?.map(item => item?.name)
          : undefined,
        account_type:
          formik.values.account_type === ""
            ? undefined
            : formik.values.account_type,
      },
    }

    if (payload?.filter?.subLedger === "") {
      delete payload?.filter?.subLedger;
    }


    if (filters?.search) {
      payload = {
        ...payload,
        search: filters?.search
      }
    }


    {
      formik.values?.batch_type === "previous_amount"
        ? await FinanceService.getListofPreviousAmountAccounts(
          token,
          page + 1,
          20,
          payload,
        ).then((res) => {
          const result = res?.payload?.data;

          formik.setFieldValue(
            "amountIsSame",
            result.every((item) => !!item.payment?.balance)
          );

          setProductData(result);
          setLoading(false);
          setCount(res?.payload?.pagination?.count);
        }).catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        })
        : await FinanceService.getListofAccounts(token, page + 1, 50, {
          ...filters,
          filter:
            filters?.filter &&
              Object.values(filters.filter).every((item) => !item)
              ? undefined
              : {
                ...filters?.filter,
                billing_type: filters?.filter?.billing_type?.map(item => item?.name)
              },
          sort:
            filters?.sort &&
              Object.values(filters.sort).every((item) => !item)
              ? undefined
              : filters?.sort,
        }).then((res) => {
          setLoading(false);
          const result = res?.payload?.data;
          // setSelectedAccounts([
          //   ...result.map((item) => ({
          //     id: item._id,
          //     name: item?.admin_name ?? item?.family_name,
          //   })),
          // ]);
          // setSelectedAccountsWithAmount([
          //   ...result.map((item) => ({
          //     id: item._id,
          //     name: item?.admin_name ?? item?.family_name,
          //     amount: item?.payment?.balance ?? 0,
          //   })),
          // ]);
          setSubTotalAmount([
            ...result.map((item) => item?.payment?.balance),
          ]);
          let sum = lodash.sum(subTotalAmount);
          formik.setFieldValue(
            "total_previous_amount",
            CheckFloatValue(sum)
              ?.toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          );

          formik.setFieldValue(
            "amountIsSame",
            result.every((item) => !!item.payment?.balance)
          );

          setProductData(result);
          setCount(res?.payload?.pagination?.count);
        }).catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
  };

  const sortCharged = (e) => {
    setFilters((prev) => ({
      ...prev,
      sort: {
        [e]: prev?.sort?.[e] === -1 ? 1 : -1,
      },
    }));
  };

  const amountRange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev?.filter,
        amount_range: {
          ...prev?.filter?.amount_range,
          [name]: value,
        },
      },
      search: undefined,
    }));
  };

  const onClear = () => {
    setFilters({
      sort: {},
      filter: {
        billing_type:
          formik.values?.batch_type === "account"
            ? formik?.values?.billing_type
            : undefined,
      },
      search: undefined,
    });
    setOnClearList(true);
    setFilters({ ...initialFilters });
  };

  const dateRange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev?.filter,
        date_range: {
          ...prev?.filter?.date_range,
          [name]: value,
        },
      },
    }));
  };
  const onBillingTypeChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        billing_type: e ? e : undefined,
      },
    }));
  };
  const onSearchChange = (e) => {
    const { value } = e.target;
    setFilters((prev) => ({
      ...prev,
      search: value ? value : undefined,
    }));
  };
  const onAccountTypeChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        account_type: e ? e : undefined,
      },
    }));
  };
  const onCategoryTypeChange = (e) => {

    setFilters((prev) => ({
      ...prev,

      filter: {
        ...prev.filter,
        category: e?.name === "" ? undefined : e?.name,
      },
    }));
  };
  const onPreviousStatusChange = (e) => {
    formik.setFieldValue("status", e);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        status: e ? e : undefined,
      },
    }));
  };

  const onAccountTagsChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        accountTags: e ? e : undefined,
      },
    }));
  };

  const onContactTagsChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        contactTags: e ? e : undefined,
      },
    }));
  };


  const debounceSearch = useCallback(
    debounce(() => {
      if (
        filters.search ||
        filters?.sort ||
        filters.filter ||
        (filters?.filter?.amount_range?.amountTo &&
          filters?.filter?.amount_range?.amountFrom) ||
        filters?.filter?.date_range ||
        filters?.filter?.status
      ) {
        fetchMyAPI();
      }
    }, 1000)
  );
  useEffect(() => {
    fetchMyAPI();
  }, [page, filters]);

  useEffect(() => {
    if (!filters.search) {
      debounceSearch();
    }
    return () => debounceSearch.cancel();
  }, [
    filters?.sort?.name,
    // !filters?.filter?.billing_type,
    // !filters?.filter?.category,
    // !filters?.filter?.account_type,
    filters?.filter?.date_range,
    filters?.filter?.amount_range,
    filters?.filter?.status,
  ]);
  // useEffect(() => {
  //   debounceSearch();
  //   return () => debounceSearch.cancel();
  // }, [filters?.search]);

  const onCheckboxClick = (e, row) => {
    const { checked } = e.target;
    if (checked) {
      const found = productData.find((item) => item._id === row._id);
      if (found) {
        setSelectedAccounts((prev) => [
          ...prev,
          {
            id: found._id,
            name: found?.name ?? found?.family_name,
            amount: found?.payment?.balance,
          },
        ]);
      }
    } else {
      setSelectedAccounts((prev) => {
        const foundIndex = prev.findIndex((item) => item.id === row._id);
        prev.splice(foundIndex, 1);
        return [...prev];
      });
    }
  };
  useEffect(() => {
    // formik.setFieldValue("total_previous_amount", sumPrevious);

    formik.setFieldValue(
      "subtotal_amount",
      (selectedAccounts?.length ?? 1) * formik.values?.amount
    );

    formik.setFieldValue("accounts_with_amount", selectedAccountsWithAmount);
    formik.setFieldValue("accountsCount", selectedAccounts?.length);
  }, [selectedAccounts]);

  return (
    <div className="batch-render-comp renderd-comp">
      <div className="batch-filter-area">
        <BatchBillingFilters
          filter={filters}
          onAccountTypeChange={onAccountTypeChange}
          onCategoryTypeChange={onCategoryTypeChange}
          onBillingTypeChange={onBillingTypeChange}
          onSearchChange={onSearchChange}
          onPreviousStatusChange={onPreviousStatusChange}
          amountRange={amountRange}
          dateRange={dateRange}
          onClear={onClear}
          debounceSearch={debounceSearch}
          formik={formik}
          setOnClearList={setOnClearList}
          onClearList={onClearList}
          onAccountTagsChange={onAccountTagsChange}
          onContactTagsChange={onContactTagsChange}
        />
      </div>
      <div className="charges-table">
        <AccountSelectionTable
          formik={formik}
          fetchMyAPI={fetchMyAPI}
          setPage={setPage}
          sortCharged={sortCharged}
          count={count}
          page={page}
          productData={productData}
          loading={loading}
          selectedData={selectedAccounts}
          onCheckboxClick={onCheckboxClick}
          setSelected={setSelectedAccounts}
          selected={selectedAccounts}
          setCheckPage={setCheckPage}
          checkPage={checkPage}
        />
      </div>
    </div>
  );
};
export default AccountsSelection;
